import { type CSSProperties, type Key } from 'react';

import { devWarn } from '../../utils';

import { type RowKey, type TableColumnType, type TableResourceRecord } from './Table.types';

export const getRowKey = <RecordType extends TableResourceRecord = any>(
    rowKey: RowKey<RecordType>
): ((record: RecordType) => Key) => {
    if (typeof rowKey === 'function') {
        return rowKey;
    }
    return (record: RecordType) => {
        const key = record && record[rowKey];
        if (key === undefined) {
            devWarn(
                'Each record in table should have a unique `key` prop, or set `rowKey` to an unique primary key.'
            );
        }
        return key;
    };
};

export const getColKey = <T>(col: TableColumnType<T>): Key => {
    if (typeof col === 'string') {
        // TableExtraColumn (should be converted to ColumnConfig when reaching this point)
        return col;
    }
    return col.key;
};

export const getColStyle = <T>(col: TableColumnType<T>) => {
    if (typeof col === 'string') {
        // TableExtraColumn (should be converted to ColumnConfig when reaching this point)
        return undefined;
    }
    const style: CSSProperties = {};
    if (col.align) {
        style.textAlign = col.align;
    }
    return style;
};
